export const getAuthToken = () => {
    if (typeof window !== undefined) return localStorage.getItem("bu-auth-token");
    return
}